import { render, staticRenderFns } from "./page.vue?vue&type=template&id=19a6b6af&"
import script from "./page.vue?vue&type=script&lang=js&"
export * from "./page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19a6b6af')) {
      api.createRecord('19a6b6af', component.options)
    } else {
      api.reload('19a6b6af', component.options)
    }
    module.hot.accept("./page.vue?vue&type=template&id=19a6b6af&", function () {
      api.rerender('19a6b6af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm_fine/views/activity_center/activity_manage/page.vue"
export default component.exports